export default __webpack_public_path__ + "static/media/lifebar2.b2ff4ca8.PNG";